import React, { useEffect } from 'react'
import Bredcom from '../../Bredcom/Main'
import Header from '../../headerone/Main'
import Mayor from '../../menhome/Mayor'
import First from '../menservices/First'
import Second from '../menservices/Second'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Services";
  }, [])

  return (
    <>
        <Header/>

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Home"
            title="Services"
            subtitledown="Services"
           />
            <First/>
            <Mayor/>
            <Second/>
        </div>
    </>
  )
}

export default Main